"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationSessionServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const WSService_audio_1 = __importStar(require("../WSService.audio"));
const component_1 = require("@front/layouts/default-layout/component");
const ConversationStreamingService_1 = __importStar(require("./ConversationStreamingService"));
const conversation_agent_events_1 = require("../../../../common/constants/conversation-agent-events");
const PopupService_1 = __importStar(require("../PopupService"));
// Import helper classes
const session_manager_helper_1 = require("@front/helpers/session-manager.helper");
const websocket_event_manager_helper_1 = require("@front/helpers/websocket-event-manager.helper");
const conversation_event_handler_helper_1 = require("@front/helpers/conversation-event-handler.helper");
/**
 * Core conversation session management service
 * Handles WebSocket communication and session lifecycle
 */
let ConversationSessionService = class ConversationSessionService extends client_1.RWSService {
    constructor(apiService, popupService, wsService, streamingService) {
        super();
        this.apiService = apiService;
        this.popupService = popupService;
        this.wsService = wsService;
        this.streamingService = streamingService;
        this.activeSessions = new Map();
        this.listeners = new Map();
        this.pendingSessionCallbacks = new Map();
        this.streamingSessions = new Map(); // Track which sessions are streaming
        this.isInitialized = false;
        this.webChatComponent = null;
    }
    init(chatComponent) {
        if (!this.isInitialized) {
            this.webChatComponent = chatComponent;
            this.setupWebSocketListeners();
            this.isInitialized = true;
            console.log('🔧 [SessionService] Initialized WebSocket listeners');
        }
        else {
            console.log('⚠️ [SessionService] Already initialized, skipping listener setup');
        }
    }
    /**
     * Start a conversation agent session
     */
    async startConversation(request, callbacks) {
        try {
            const tempKey = session_manager_helper_1.SessionManager.generateTempKey();
            // Store callbacks while waiting for backend session ID
            session_manager_helper_1.SessionManager.storePendingCallback(this.pendingSessionCallbacks, tempKey, callbacks);
            this.wsService.sendMessage('conversation_agent', conversation_agent_events_1.CONVERSATION_AGENT_ROUTES.START_CONVERSATION_AGENT, {
                ...request,
                userId: this.getCurrentUserId(),
                tempKey
            });
            return tempKey;
        }
        catch (error) {
            console.error('Failed to start conversation agent:', error);
            throw error;
        }
    }
    /**
     * Start real-time audio streaming for a session
     */
    async startAudioStreaming(sessionId, options) {
        // console.log('🎵 [SessionService] Starting audio streaming for session:', sessionId, 'with options:', options);
        var _a;
        try {
            if (session_manager_helper_1.SessionManager.isStreamingActive(this.streamingSessions, sessionId)) {
                console.log('⚠️ [SessionService] Audio streaming already active for session:', sessionId);
                return true;
            }
            console.log('🔧 [SessionService] Initializing streaming service...');
            // Initialize streaming
            const initialized = await this.streamingService.initializeStreaming(options);
            if (!initialized) {
                console.error('❌ [SessionService] Failed to initialize audio streaming');
                throw new Error('Failed to initialize audio streaming');
            }
            // console.log('🚀 [SessionService] Starting streaming with callbacks...');
            // Start streaming with real-time chunk processing            
            const success = await this.streamingService.startStreaming(
            // onAudioChunk callback - send each chunk immediately
            (audioBase64) => {
                // console.log('📨 [SessionService] Sending audio chunk to backend:', {
                //     sessionId,
                //     audioLength: audioBase64.length,
                //     preview: audioBase64.substring(0, 50) + '...'
                // });                    
                this.sendAudioChunk(sessionId, audioBase64, this.getCurrentUserId());
            }, 
            // onVADScore callback - for voice activity monitoring
            (vadScore) => {
                // Could emit VAD score to UI if needed
                console.debug('🎙️ [SessionService] VAD Score:', vadScore.toFixed(2));
            });
            if (success) {
                session_manager_helper_1.SessionManager.setStreamingActive(this.streamingSessions, sessionId, true);
                console.log('✅ [SessionService] Started real-time audio streaming for session:', sessionId);
            }
            else {
                console.error('❌ [SessionService] Failed to start streaming');
            }
            return success;
        }
        catch (error) {
            console.error('💥 [SessionService] Failed to start audio streaming:', error);
            const callbacks = this.activeSessions.get(sessionId);
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, error.message);
            return false;
        }
    }
    /**
     * Stop real-time audio streaming for a session
     */
    async stopAudioStreaming(sessionId) {
        var _a;
        console.log('🛑 [SessionService] Stopping audio streaming for session:', sessionId);
        try {
            if (!session_manager_helper_1.SessionManager.isStreamingActive(this.streamingSessions, sessionId)) {
                console.log('⚠️ [SessionService] Audio streaming not active for session:', sessionId);
                return true;
            }
            // Stop local audio streaming
            await this.streamingService.stopStreaming();
            session_manager_helper_1.SessionManager.setStreamingActive(this.streamingSessions, sessionId, false);
            // Send message to backend to stop Azure STT session
            await this.sendStopRecordingMessage(sessionId);
            console.log('✅ [SessionService] Stopped audio streaming for session:', sessionId);
            return true;
        }
        catch (error) {
            console.error('💥 [SessionService] Failed to stop audio streaming:', error);
            const callbacks = this.activeSessions.get(sessionId);
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError) === null || _a === void 0 ? void 0 : _a.call(callbacks, error.message);
            return false;
        }
    }
    /**
     * Send stop recording message to backend to disconnect Azure STT session
     */
    async sendStopRecordingMessage(sessionId) {
        try {
            console.log('📡 [SessionService] Sending stop recording message to backend for session:', sessionId);
            this.wsService.sendMessage('conversation_agent', 'stop_recording', {
                sessionId
            });
            console.log('✅ [SessionService] Stop recording message sent successfully');
        }
        catch (error) {
            console.error('💥 [SessionService] Failed to send stop recording message:', error);
            // Don't throw error as local streaming was already stopped
        }
    }
    /**
     * Send WebSocket message to backend
     */
    sendWebSocketMessage(route, data) {
        this.wsService.sendMessage('conversation_agent', route, data);
    }
    /**
     * Send real-time audio chunk to backend
     */
    async sendAudioChunk(sessionId, audioBase64, userId) {
        // Always allow audio chunks during agent speech for interruptions
        // Only skip when agent is thinking (processing user input)
        if (this.webChatComponent &&
            (!this.webChatComponent.userTurn && this.webChatComponent.isThinking)) {
            return;
        }
        try {
            this.wsService.sendMessage('conversation_agent', conversation_agent_events_1.CONVERSATION_AGENT_ROUTES.SEND_AGENT_MESSAGE, {
                sessionId,
                audioData: audioBase64,
                userId,
                isAudioInput: true
            });
        }
        catch (error) {
            console.error('💥 [SessionService] Failed to send audio chunk:', error);
            // Don't throw error for individual chunks to avoid stopping the stream
        }
    }
    /**
     * Start manual recording (legacy method - kept for compatibility)
     */
    async startManualRecording(sessionId, options) {
        // Default streaming options with VAD enabled
        const streamingOptions = {
            enableVAD: true,
            ...options
        };
        // Redirect to streaming for real-time experience
        return this.startAudioStreaming(sessionId, streamingOptions);
    }
    /**
     * Stop recording and send audio (legacy method - now stops streaming)
     */
    async stopVoiceStreaming() {
        try {
            // For streaming mode, just stop the streaming
            const sessionIds = session_manager_helper_1.SessionManager.getStreamingSessionIds(this.streamingSessions);
            for (const sessionId of sessionIds) {
                await this.stopAudioStreaming(sessionId);
            }
            return true;
        }
        catch (error) {
            console.error('Failed to stop voice streaming:', error);
            return false;
        }
    }
    /**
     * Send PCM audio data to backend
     */
    async sendAudioPCM(sessionId, audioBase64, userId) {
        // Only send audio if it's the user's turn and the agent is not thinking/speaking
        if (this.webChatComponent &&
            (!this.webChatComponent.userTurn || this.webChatComponent.isThinking || this.webChatComponent.isSpeaking)) {
            return;
        }
        try {
            this.wsService.sendMessage('conversation_agent', conversation_agent_events_1.CONVERSATION_AGENT_ROUTES.SEND_AGENT_MESSAGE, {
                sessionId,
                audioData: audioBase64,
                userId,
                isAudioInput: true
            });
        }
        catch (error) {
            console.error('Failed to send PCM audio:', error);
            throw error;
        }
    }
    /**
     * End a conversation agent session
     */
    async endConversationAgent(sessionId, reason = 'unknown') {
        try {
            console.log('🛑 [SessionService] Ending conversation agent for session:', sessionId, 'Reason:', reason);
            // Stop streaming if active
            if (session_manager_helper_1.SessionManager.isStreamingActive(this.streamingSessions, sessionId)) {
                console.log('🔇 [SessionService] Stopping audio streaming for session:', sessionId);
                await this.stopAudioStreaming(sessionId);
            }
            this.wsService.sendMessage('conversation_agent', conversation_agent_events_1.CONVERSATION_AGENT_ROUTES.END_CONVERSATION_AGENT, {
                sessionId,
                userId: this.getCurrentUserId(),
                reason: reason
            });
            // Clean up local session and any pending callbacks
            session_manager_helper_1.SessionManager.cleanupSession(this.activeSessions, this.streamingSessions, this.pendingSessionCallbacks, sessionId);
            console.log('✅ [SessionService] Session ended and cleaned up:', sessionId);
            return true;
        }
        catch (error) {
            console.error('💥 [SessionService] Failed to end conversation agent:', error);
            throw error;
        }
    }
    /**
     * Check if a session has active audio streaming
     */
    isStreamingActive(sessionId) {
        return session_manager_helper_1.SessionManager.isStreamingActive(this.streamingSessions, sessionId);
    }
    /**
     * Check if a session is active
     */
    isSessionActive(sessionId) {
        return session_manager_helper_1.SessionManager.isSessionActive(this.activeSessions, sessionId);
    }
    /**
     * Check if WebSocket is connected
     */
    isWsConnected() {
        return this.wsService.isActive();
    }
    getCurrentUserId() {
        return component_1.DefaultLayout.USER.id;
    }
    setupWebSocketListeners() {
        // Setup all WebSocket listeners using the helper
        websocket_event_manager_helper_1.WebSocketEventManager.setupListeners(this.wsService, this.listeners, {
            handleSessionStarted: (wsResponse) => this.handleSessionStarted(wsResponse),
            handleAgentError: (wsResponse) => this.handleAgentError(wsResponse),
            handleSessionEnded: (wsResponse) => this.handleSessionEnded(wsResponse),
            handleUserTranscription: (wsResponse) => this.handleUserTranscription(wsResponse),
            handleAgentStatus: (wsResponse) => this.handleAgentStatus(wsResponse),
            handleContextUpdated: (wsResponse) => this.handleContextUpdated(wsResponse),
            handleAgentConfigured: (wsResponse) => this.handleAgentConfigured(wsResponse),
            handlePartialTranscription: (wsResponse) => this.handlePartialTranscription(wsResponse),
            handleAudioResponse: (wsResponse) => this.handleAudioResponse(wsResponse),
            handleTextResponse: (wsResponse) => this.handleTextResponse(wsResponse),
            handleStopRecording: (wsResponse) => this.handleStopRecording(wsResponse),
            handleConversationMessage: (wsResponse) => this.handleConversationMessage(wsResponse),
            handleSessionTimeout: (wsResponse) => this.handleSessionTimeout(wsResponse),
            handleSTTSessionStop: (wsResponse) => this.handleSTTSessionStop(wsResponse)
        });
    }
    // Event handlers - delegate to ConversationEventHandler
    handleSessionStarted(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleSessionStarted(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleSessionEnded(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleSessionEnded(this.activeSessions, wsResponse);
    }
    handleAgentError(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleAgentError(this.activeSessions, this.pendingSessionCallbacks, wsResponse, this.popupService, this.webChatComponent, (sessionId) => this.endConversationAgent(sessionId));
    }
    handleUserTranscription(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleUserTranscription(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleAgentStatus(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleAgentStatus(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleContextUpdated(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleGenericEvent('context_updated');
    }
    handleAgentConfigured(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleGenericEvent('agent_configured');
    }
    handlePartialTranscription(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handlePartialTranscription(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleAudioResponse(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleAudioResponse(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleTextResponse(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleTextResponse(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleStopRecording(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleStopRecording(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleConversationMessage(wsResponse) {
        conversation_event_handler_helper_1.ConversationEventHandler.handleConversationMessage(this.activeSessions, this.pendingSessionCallbacks, wsResponse);
    }
    handleSessionTimeout(wsResponse) {
        var _a;
        console.log('⏰ [SessionService] Session timeout received:', wsResponse);
        // End the conversation and notify the component
        if (this.webChatComponent) {
            console.log('⏰ [SessionService] Notifying voice-chat component of timeout');
            this.webChatComponent.errorMessage = 'voice_chat.session_timeout'.t();
            this.webChatComponent.endConversation('timeout');
        }
        // Clean up the session
        if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
            this.activeSessions.delete(wsResponse.data.sessionId);
            this.streamingSessions.delete(wsResponse.data.sessionId);
        }
    }
    handleSTTSessionStop(wsResponse) {
        var _a;
        console.log('🛑 [SessionService] STT session stop received:', wsResponse);
        // Stop audio streaming for the session
        if ((_a = wsResponse.data) === null || _a === void 0 ? void 0 : _a.sessionId) {
            const sessionId = wsResponse.data.sessionId;
            console.log('🔇 [SessionService] Stopping STT session - transcription sent to LLM:', sessionId);
            // Stop streaming but don't throw errors - this is expected behavior
            this.stopAudioStreaming(sessionId).catch(error => {
                console.warn('⚠️ [SessionService] Error stopping STT session (expected):', error);
            });
            // Update component state to show thinking
            if (this.webChatComponent) {
                this.webChatComponent.isRecording = false;
                this.webChatComponent.isThinking = true;
                console.log('🤔 [SessionService] Component updated - thinking mode enabled');
            }
        }
    }
    /**
     * Cleanup all WebSocket listeners
     */
    cleanupWebSocketListeners() {
        websocket_event_manager_helper_1.WebSocketEventManager.cleanupListeners(this.listeners);
    }
    /**
     * Listen for a specific WebSocket event (public interface for components)
     */
    listenForEvent(eventName, callback) {
        return websocket_event_manager_helper_1.WebSocketEventManager.listenForCustomEvent(this.wsService, eventName, callback);
    }
    destroy() {
        this.cleanupWebSocketListeners();
        // Stop all streaming sessions
        this.streamingService.destroy();
        // Clear all session data using SessionManager
        session_manager_helper_1.SessionManager.clearAllSessions(this.activeSessions, this.streamingSessions, this.pendingSessionCallbacks);
        // Reset initialization flag
        this.isInitialized = false;
        this.webChatComponent = null;
        console.log('🧹 [SessionService] Destroyed and reset initialization state');
    }
};
exports.ConversationSessionServiceInstance = ConversationSessionService;
exports.ConversationSessionServiceInstance = ConversationSessionService = __decorate([
    __param(0, client_1.ApiService),
    __param(1, PopupService_1.default),
    __param(2, WSService_audio_1.default),
    __param(3, ConversationStreamingService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object, typeof (_b = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _b : Object, typeof (_c = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _c : Object, typeof (_d = typeof ConversationStreamingService_1.ConversationStreamingServiceInstance !== "undefined" && ConversationStreamingService_1.ConversationStreamingServiceInstance) === "function" ? _d : Object])
], ConversationSessionService);
exports.default = ConversationSessionService.getSingleton();
